export default __webpack_public_path__ + "static/media/banner_s.65c1dce1.png";